/** Google Fonts（Inter / Noto Sans JP）で実際に使っているウェイトのみ */
export const GOOGLE_FONTS_STYLESHEET =
  'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;900&family=Noto+Sans+JP:wght@400;500;600;700;900&display=swap'
